import React from "react"
import {
  // CheckboxYesNo,
  FormContainer,
  formatCurrency,
  LabeledInput,
  DatePicker,
  Worksheet
} from "uikit"
import { Dropdown, Input } from "semantic-ui-react"
import { paymentFrequencyOptions } from "../../dropDownOptions"
import { Footer } from "./Footer"
import { PAY_FREQUENCY_DIVISOR } from "components/incomes/dropDownOptions"

const ChildSupportForm = ({
  data: {
    fields: { description, payment_amount, pay_frequency, until_date },
    isModified,
    onSubmit,
    error
  },
  submitLabel = "Done",
  onDelete,
  isNew
}) => {
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row label={"Description of income"} paddedField>
          <Worksheet.Field error={description.error}>
            <Input {...description} autoComplete="off" />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="How much is each child support payment?"
          paddedField
        >
          <Worksheet.Field error={payment_amount.error}>
            <LabeledInput
              {...payment_amount}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="How frequently do you receive it?" paddedField>
          <Worksheet.Field error={pay_frequency.error}>
            <Dropdown
              placeholder="Frequency"
              selection
              options={paymentFrequencyOptions}
              data-testid="pay_frequency"
              {...pay_frequency}
            />
            {payment_amount.value && pay_frequency.value && (
              <span style={{ fontWeight: "normal" }}>
                Approximately{" "}
                {formatCurrency(
                  Math.floor(
                    payment_amount.object *
                      PAY_FREQUENCY_DIVISOR[pay_frequency.object]
                  )
                )}{" "}
                per year
              </span>
            )}
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="Until when will you receive these support payments?"
          paddedField
        >
          <Worksheet.Field error={until_date.error}>
            <DatePicker {...until_date} />
          </Worksheet.Field>
        </Worksheet.Row>
      </Worksheet.Body>
      <Footer
        isNew={isNew}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        onDelete={onDelete}
        isModified={isModified}
        deleteLabel="Delete Income"
        error={error}
      />
    </Worksheet>
  )
}

const ChildSupportFormContainer = FormContainer(
  {
    description: {
      type: "string",
      defaultValue: "Child Support"
    },
    payment_amount: {
      type: "unit"
    },
    pay_frequency: {
      type: "string",
      defaultValue: "monthly"
    },
    until_date: {
      type: "date",
      minValue: new Date(),
      maxValue: new Date(new Date().getFullYear() + 75, 0, 1)
    },
    type: {
      type: "string",
      defaultValue: "childsupport"
    }
  },
  (fields, ...form) => {}
)(ChildSupportForm)

const ChildSupport = ({ isNew, income, ...formProps }) => {
  const values = isNew ? {} : income
  return (
    <ChildSupportFormContainer
      {...{
        values,
        ...formProps
      }}
    />
  )
}

export default ChildSupport
